import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, Link } from '@mui/material';
import ModalDialogMUI6 from 'src/components/ModalDialogMUI6';
import ROUTES from 'src/constants/routes';

function GoogleDocLinkModal({
  isVisible,
  onClose,
  docUrl,
  docTitle,
  userEmail,
  userGmail,
}) {
  const handleOpenDocument = () => {
    window.open(docUrl, '_blank', 'noopener,noreferrer');
  };

  const isEmailGmail = userEmail && userEmail.toLowerCase().endsWith('@gmail.com');
  const isGmailFieldGmail = userGmail && userGmail.toLowerCase().endsWith('@gmail.com');

  let messageContent;

  if (isEmailGmail) {
    messageContent = (
      <Typography variant="body1" align="center">
        Make sure you&apos;re logged into Google as
        {' '}
        <strong>{userEmail}</strong>
        {' '}
        in this browser to access this document.
      </Typography>
    );
  } else if (isGmailFieldGmail) {
    messageContent = (
      <Typography variant="body1" align="center">
        Make sure you&apos;re logged into Google as
        {' '}
        <strong>{userGmail}</strong>
        {' '}
        in this browser to access this document.
      </Typography>
    );
  } else {
    messageContent = (
      <Box>
        <Typography variant="body1" align="center" sx={{ mb: 2 }}>
          You may not be able to access this document.
        </Typography>
        <Typography variant="body2" align="center" color="textSecondary">
          To fix this, add your Gmail address in
          {' '}
          <Link
            href={ROUTES.APP_ACCOUNT}
            target="_blank"
            rel="noopener noreferrer"
          >
            Settings &gt; Your Info
          </Link>
        </Typography>
      </Box>
    );
  }

  const modalContent = (
    <Box sx={{ textAlign: 'center' }}>
      <Typography
        variant="h6"
        sx={{ mb: 2, fontWeight: 500 }}
      >
        {docTitle}
      </Typography>
      {messageContent}
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{ display: 'block', mt: 3 }}
      >
        If you have issues, please text our support at 317-456-5610
      </Typography>
    </Box>
  );

  return (
    <ModalDialogMUI6
      isVisible={isVisible}
      title="Opening Google Document"
      onClose={onClose}
      onOk={handleOpenDocument}
      okText="Open Document"
      closeText="Close"
      buttonsListOrder={['ok', 'close']}
      okStyleType="ok"
      closeStyleType="close"
      content={modalContent}
      modalSize="sm"
    />
  );
}

GoogleDocLinkModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  docUrl: PropTypes.string,
  docTitle: PropTypes.string,
  userEmail: PropTypes.string,
  userGmail: PropTypes.string,
};

GoogleDocLinkModal.defaultProps = {
  docUrl: '',
  docTitle: '',
  userEmail: '',
  userGmail: '',
};

export default GoogleDocLinkModal;
